export default __webpack_public_path__ + "static/media/pbi-theme-color-picker.72fe80a4.webp";